import {lazy, Suspense} from "react";
import { PageSkeleton } from "../../../customs/skeleton/main";


const Main = lazy(() => import("../../../components/application/corporateProfileUpdate/changeOfOfficer/main"));

const CorporateProfileUpdateChangeOfOfficer = () => {

    return(

        <Suspense fallback={<PageSkeleton />}>
            <Main/>
        </Suspense>
      
    )
};

export default CorporateProfileUpdateChangeOfOfficer;